import { PositionStrategy } from './position/position-strategy';
import { ScrollStrategy } from './scroll/scroll-strategy';

export class OverlayOptions {
	positionStrategy?: PositionStrategy;
	scrollStrategy?: ScrollStrategy;
	className? = 'c-overlay';
	containerClassName? = 'c-overlay__container';
	overlayClassName?: string;
	backdropClassName? = 'c-overlay-dark-backdrop';
	portalClassName?: string;
	hasBackdrop? = true;
	width?: number | string;
	height?: number | string;
	minWidth?: number | string;
	minHeight?: number | string;
	maxWidth?: number | string;
	maxHeight?: number | string;
	transitionDuration? = 300;
	showingClassName? = 'is-showing';
	baseBackdropClassName? = `c-overlay__backdrop`;
	hidingClassName? = 'is-fade-out';
	visibleClassName? = 'is-visible';
	disposeAfterClose? = false;
	detachBackdropBeforeClose? = false;
	closeOnBackdropClick? = false;
	closeOnEscPressed? = true;
	closeOnClick? = false;

	constructor(options?: OverlayOptions) {
		if (options) {
			Object.keys(options)
				.filter((key) => options[key] !== undefined)
				.forEach((key) => (this[key] = options[key]));
		}
		this.containerClassName = `${this.className}__container`;
		this.baseBackdropClassName = `${this.className}__backdrop`;
	}
}
